/* Kiwi: keep Klaviyo Back-in-Stock button alive across Alpine variant-change morphs.
   The Pipeline theme re-fetches the product HTML and morphs the buy-button area on every
   variant change. Klaviyo injects #klaviyo-bis-button-container once (on an available->sold-out
   transition); the morph then tears it out on the next variant change and Klaviyo does not
   re-inject when going sold-out -> sold-out, so the button vanishes. Fix: tag Klaviyo's
   container with data-morph-skip so the morph leaves it in place, and show/hide it to match
   the currently selected variant's availability. The Klaviyo form reads the live variant from
   the theme's hidden id input at open time, so a persisted button always targets the right variant. */
(function () {
  'use strict';
  var CONTAINER_ID = 'klaviyo-bis-button-container';
  var running = false;

  function currentlySoldOut() {
    var addBtn = document.querySelector('[data-add-to-cart]');
    // Theme adds disabled to the add-to-cart button when current_variant.available is false.
    if (addBtn) return addBtn.hasAttribute('disabled');
    // No add-to-cart button present: the container only exists in a sold-out context, so default true.
    return true;
  }

  function sync() {
    if (running) return;
    running = true;
    try {
      var nodes = document.querySelectorAll('#' + CONTAINER_ID);
      if (nodes.length) {
        // Keep the most recently injected container; drop any duplicates Klaviyo may add.
        var keep = nodes[nodes.length - 1];
        for (var i = 0; i < nodes.length - 1; i++) {
          if (nodes[i] !== keep) nodes[i].remove();
        }
        // Protect it from @alpinejs/morph so it survives subsequent variant changes.
        if (!keep.hasAttribute('data-morph-skip')) keep.setAttribute('data-morph-skip', '');
        // Only show it when the current variant is actually sold out.
        var target = currentlySoldOut() ? '' : 'none';
        if (keep.style.display !== target) keep.style.display = target;
      }
    } finally {
      running = false;
    }
  }

  sync();
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);

  // Run synchronously on any relevant DOM change (Klaviyo injecting the button, or the theme
  // morphing the add-to-cart button's disabled state on variant change). Avoid requestAnimationFrame
  // so it still fires in background/inactive tabs.
  var mo = new MutationObserver(sync);
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });
})();
